module.exports = __webpack_public_path__ + "static/media/buxom.4ff16aaf.jpg";